export const TEST_IDS = {
    COMPLIANCE_TOOLS_DROPDOWN: "compliance-tools-dropdown",
};
